import { NgZone } from '@angular/core';
import { ZoneOutsideTickerOptions } from './zone-outside-ticker-options.model';

const MILLISECONDS_PER_SECOND = 1000;

export class ZoneOutsideTicker {
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private lastTickTime: number | null = null;
  private tickAccumulator = 0;

  private readonly intervalMs: number;
  private readonly onTick: (wholeSeconds: number) => void;

  constructor(
    private readonly zone: NgZone,
    options: ZoneOutsideTickerOptions
  ) {
    this.intervalMs = options.intervalMs;
    this.onTick = options.onTick;
  }

  start(): void {
    if (this.intervalId) {
      return;
    }

    this.lastTickTime = performance.now();
    this.tickAccumulator = 0;

    this.zone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => this.tick(), this.intervalMs);
    });
  }

  stop(): void {
    if (!this.intervalId) {
      return;
    }

    clearInterval(this.intervalId);
    this.intervalId = null;
    this.lastTickTime = null;
    this.tickAccumulator = 0;
  }

  private tick(): void {
    const now = performance.now();
    const deltaMs =
      this.lastTickTime !== null ? now - this.lastTickTime : this.intervalMs;
    this.lastTickTime = now;

    this.tickAccumulator += deltaMs / MILLISECONDS_PER_SECOND;
    const wholeSeconds = Math.floor(this.tickAccumulator);

    if (wholeSeconds === 0) {
      return;
    }

    this.tickAccumulator -= wholeSeconds;

    this.zone.run(() => this.onTick(wholeSeconds));
  }
}
